/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-11-10 11:22:10
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-10 18:39:46
 */
import React from 'react';
import Loadable from 'react-loadable';
import Header4 from '../../Header/Header4'
import './index.css'
import { Spin } from 'antd';

const LoadableComponent = Loadable({
    loader: () => import('./index.jsx'),
    loading() {
        return (
            <div>
                <Header4></Header4>
                <div className="geovis-spin-wrap">
                    {/* <div style={{ width: '100%', height: '100%', color: 'black', textAlign: "center", fontSize: '2em' }}>正在加载......</div> */}
                    <Spin tip="地球加载中......" size="large"></Spin>
                </div>
            </div>
        )
    }
});

export default () => <LoadableComponent />